// import React, { useMemo } from "react";
// import { useZone } from "../../../context/ZoneContext";
// import { useTabsFilter } from "../../../context/TabsFilterContext";
// import "./style.css";

// function Classification({ lang }) {
//   const { units, availability, types } = useZone();
//   const {
//     activeTab,
//     availabilitySelection,
//     typeSelection,
//     progressSelection,
//     onFilterChange,
//   } = useTabsFilter();

//   // 1. حساب الإحصائيات الأساسية لكل الفئات
//   const stats = useMemo(() => {
//     const counts = { types: {}, availability: {}, progress: {} };
//     if (units) {
//       units.forEach((unit) => {
//         if (unit.type?.id)
//           counts.types[unit.type.id] = (counts.types[unit.type.id] || 0) + 1;
//         if (unit.availability?.id)
//           counts.availability[unit.availability.id] =
//             (counts.availability[unit.availability.id] || 0) + 1;
//         if (unit.progressCategory)
//           counts.progress[unit.progressCategory] =
//             (counts.progress[unit.progressCategory] || 0) + 1;
//       });
//     }
//     return counts;
//   }, [units]);

//   // 2. وظيفة مساعدة لجلب أسماء الفئات
//   const getCategoryName = (cat, lang) => {
//     const names = {
//       excellent: lang === "ar" ? "ممتاز" : "Excellent",
//       good: lang === "ar" ? "جيد" : "Good",
//       normal: lang === "ar" ? "متوسط" : "Normal",
//       bad: lang === "ar" ? "منخفض" : "Bad",
//     };
//     return names[cat] || cat;
//   };

//   // 3. بناء البيانات التي ستظهر في القائمة (تحتاج لتعريفها قبل totalCount)
//   const { displayData, currentSelection, filterKey } = useMemo(() => {
//     let data = [];
//     let selection = [];
//     let key = "";

//     switch (activeTab) {
//       case "availability":
//         data = (availability || []).map((item) => ({
//           ...item,
//           count: stats.availability[item.id] || 0,
//         }));
//         selection = availabilitySelection || [];
//         key = "availability";
//         break;
//       case "type":
//         data = (types || []).map((item) => ({
//           ...item,
//           count: stats.types[item.id] || 0,
//         }));
//         selection = typeSelection || [];
//         key = "type";
//         break;
//       case "construction":
//         const categoriesMap = units.reduce((acc, unit) => {
//           if (unit.progressCategory && !acc[unit.progressCategory]) {
//             acc[unit.progressCategory] = {
//               id: unit.progressCategory,
//               color: unit.progressColor,
//               name: getCategoryName(unit.progressCategory, lang),
//               count: stats.progress[unit.progressCategory] || 0,
//             };
//           }
//           return acc;
//         }, {});
//         const order = ["excellent", "good", "normal", "bad"];
//         data = order
//           .filter((cat) => categoriesMap[cat])
//           .map((cat) => categoriesMap[cat]);
//         selection = progressSelection || [];
//         key = "construction";
//         break;
//       default:
//         data = [];
//     }
//     return { displayData: data, currentSelection: selection, filterKey: key };
//   }, [
//     activeTab,
//     availability,
//     types,
//     units,
//     stats,
//     availabilitySelection,
//     typeSelection,
//     progressSelection,
//     lang,
//   ]);
//   const totalCount = useMemo(() => {
//     return displayData
//       .filter((item) => !currentSelection.includes(item.id))
//       .reduce((sum, item) => sum + item.count, 0);
//   }, [displayData, currentSelection]);

//   if (displayData.length === 0) return null;

//   return (
//     <div className="classification-container">
//       <div className="classification-list">
//         {displayData.map((item) => {
//           const isSelected = currentSelection.includes(item.id);
//           return (
//             <div
//               key={item.id}
//               className={`classification-item ${isSelected ? "active" : "inactive"}`}
//               // onClick={() => handleToggle(item)}
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: "10px",
//                 padding: "6px 0",
//               }}
//             >
//               <div
//                 style={{
//                   color: "#fff",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                 }}
//               >
//                 <span
//                   className="color-dot"
//                   style={{
//                     width: "12px",
//                     height: "12px",
//                     borderRadius: "50%",
//                     backgroundColor: item.color || item.progressColor || "#ccc",
//                     border: isSelected
//                       ? "1.5px solid #fff"
//                       : "1.5px solid transparent",
//                   }}
//                 ></span>
//                 <span
//                   className="item-name"
//                   style={{
//                     color: "#fff",
//                     fontSize: "13px",
//                     fontWeight: isSelected ? "600" : "400",
//                   }}
//                 >
//                   {item.name || item.title || item.id}
//                 </span>
//               </div>
//               <span
//                 style={{
//                   color: "#fff",
//                   fontSize: "11px",
//                   // backgroundColor: "rgba(255,255,255,0.1)",
//                   padding: "2px 6px",
//                   borderRadius: "10px",
//                   minWidth: "20px",
//                   textAlign: "center",
//                 }}
//               >
//                 {item.count}
//               </span>
//             </div>
//           );
//         })}
//       </div>

//       <div
//         style={{
//           marginTop: "12px",
//           paddingTop: "8px",
//           borderTop: "1px solid rgba(255,255,255,0.1)",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <span style={{ color: "#fff", fontSize: "13px", fontWeight: "600" }}>
//           {lang === "ar" ? "الإجمالي" : "Total"}
//         </span>
//         <span
//           style={{
//             color: "#fff",
//             fontSize: "12px",
//             fontWeight: "700",
//             //   backgroundColor: "rgba(255,255,255,0.2)",
//             padding: "2px 8px",
//             borderRadius: "4px",
//           }}
//         >
//           {totalCount}
//         </span>
//       </div>
//     </div>
//   );
// }

// export default Classification;
import React, { useMemo } from "react";
import { useZone } from "../../../context/ZoneContext";
import { useTabsFilter } from "../../../context/TabsFilterContext";
import "./style.css";

function Classification({ lang }) {
  const { units, availability, types } = useZone();
  const {
    activeTab,
    availabilitySelection,
    typeSelection,
    progressSelection,
    bookingDate,
    onFilterChange,
  } = useTabsFilter();

  // 1. حساب الإحصائيات (تعديل حساب التاريخ ليصبح عداد إجمالي)
  const stats = useMemo(() => {
    const counts = { types: {}, availability: {}, progress: {}, bookingTotal: 0 }; // هنا عداد رقمي
    if (units) {
      units.forEach((unit) => {
        if (unit.type?.id)
          counts.types[unit.type.id] = (counts.types[unit.type.id] || 0) + 1;
        if (unit.availability?.id)
          counts.availability[unit.availability.id] =
            (counts.availability[unit.availability.id] || 0) + 1;
        if (unit.progressCategory)
          counts.progress[unit.progressCategory] =
            (counts.progress[unit.progressCategory] || 0) + 1;
        
        // إذا كان للوحدة تاريخ حجز، زود العداد الإجمالي بواحد
        if (unit.bookingDate || unit.booking_date) {
          counts.bookingTotal += 1;
        }
      });
    }
    return counts;
  }, [units]);

  const getCategoryName = (cat, lang) => {
    const names = {
      excellent: lang === "ar" ? "ممتاز" : "Excellent",
      good: lang === "ar" ? "جيد" : "Good",
      normal: lang === "ar" ? "متوسط" : "Normal",
      bad: lang === "ar" ? "منخفض" : "Bad",
    };
    return names[cat] || cat;
  };

  // 2. بناء البيانات (تعديل حالة bookingDate لتظهر سطر واحد فقط)
  const { displayData, currentSelection, filterKey } = useMemo(() => {
    let data = [];
    let selection = [];
    let key = "";

    switch (activeTab) {
      case "availability":
        data = (availability || []).map((item) => ({
          ...item,
          count: stats.availability[item.id] || 0,
        }));
        selection = availabilitySelection || [];
        key = "availability";
        break;
      case "type":
        data = (types || []).map((item) => ({
          ...item,
          count: stats.types[item.id] || 0,
        }));
        selection = typeSelection || [];
        key = "type";
        break;
      case "construction":
        const categoriesMap = units.reduce((acc, unit) => {
          if (unit.progressCategory && !acc[unit.progressCategory]) {
            acc[unit.progressCategory] = {
              id: unit.progressCategory,
              color: unit.progressColor,
              name: getCategoryName(unit.progressCategory, lang),
              count: stats.progress[unit.progressCategory] || 0,
            };
          }
          return acc;
        }, {});
        const order = ["excellent", "good", "normal", "bad"];
        data = order
          .filter((cat) => categoriesMap[cat])
          .map((cat) => categoriesMap[cat]);
        selection = progressSelection || [];
        key = "construction";
        break;

      case "bookingDate":
        // إظهار سطر واحد فقط يجمع كل المحجوز
        data = [{
          id: "all_booked",
          name: lang === "ar" ? "وحدات محجوزة" : "Booked Units",
          color: "#44ae5a",
          count: stats.bookingTotal, // الرقم الإجمالي
        }];
        selection = bookingDate ? ["all_booked"] : [];
        key = "bookingDate";
        break;

      default:
        data = [];
    }
    return { displayData: data, currentSelection: selection, filterKey: key };
  }, [activeTab, availability, types, units, stats, availabilitySelection, typeSelection, progressSelection, bookingDate, lang]);

  const totalCount = useMemo(() => {
    return displayData
      .filter((item) => !currentSelection.includes(item.id))
      .reduce((sum, item) => sum + item.count, 0);
  }, [displayData, currentSelection]);

  if (displayData.length === 0) return null;

  return (
    <div className="classification-container">
      <div className="classification-list">
        {displayData.map((item) => {
          const isSelected = currentSelection.includes(item.id);
          return (
            <div
              key={item.id}
              className={`classification-item ${isSelected ? "active" : "inactive"}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "10px",
                padding: "6px 0",
              }}
            >
              <div
                style={{
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <span
                  className="color-dot"
                  style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: item.color || item.progressColor || "#ccc",
                    border: isSelected ? "1.5px solid #fff" : "1.5px solid transparent",
                  }}
                ></span>
                <span
                  className="item-name"
                  style={{
                    color: "#fff",
                    fontSize: "13px",
                    fontWeight: isSelected ? "600" : "400",
                    fontFamily: lang === "ar" ? "'Almarai', sans-serif" : "inherit"
                  }}
                >
                  {item.name || item.title || item.id}
                </span>
              </div>
              <span
                style={{
                  color: "#fff",
                  fontSize: "11px",
                  padding: "2px 6px",
                  borderRadius: "10px",
                  minWidth: "20px",
                  textAlign: "center",
                }}
              >
                {item.count}
              </span>
            </div>
          );
        })}
      </div>

      <div
        style={{
          marginTop: "12px",
          paddingTop: "8px",
          borderTop: "1px solid rgba(255,255,255,0.1)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ color: "#fff", fontSize: "13px", fontWeight: "600", fontFamily: lang === "ar" ? "'Almarai', sans-serif" : "inherit" }}>
          {lang === "ar" ? "الإجمالي" : "Total"}
        </span>
        <span
          style={{
            color: "#fff",
            fontSize: "12px",
            fontWeight: "700",
            padding: "2px 8px",
            borderRadius: "4px",
          }}
        >
          {totalCount}
        </span>
      </div>
    </div>
  );
}

export default Classification;